function SendGTAGEvent(event_name, category , action, email){
    window.gtag('event', `${event_name}`, {
        'category' : `${category}`,
        'action': `${action}`,
        'email': `${email}`,
    });
}

export default SendGTAGEvent;